// store/clientsSlice.js
import { getClients } from "@/pages/api/api";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  clients: [],
  status: 'idle', // status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const fetchClients = createAsyncThunk(
  'clients/fetchClients',
  async (_, thunkAPI) => {
    try {
      const response = await getClients()
    //   console.debug("RES{", response.json())
    //   if (!response.ok) {
    //     throw new Error('Error fetching sites');
    //   }
      // console.debug("RES{---", response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClientsState: (state, action) => {
      state.clients = action.payload;
    },
    updateClient: (state, action) => {
      const index = state.clients.findIndex(c => c.client_id === action.payload.client_id);
      if (index !== -1) {
        state.clients[index] = {...state.clients[index], ...action.payload};
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.clients = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setClientsState, updateClient } = clientsSlice.actions;
export default clientsSlice.reducer;
